import Nav from "@/components/Nav";
import Programme from "@/components/Programme";
import Footer from "@/components/Footer";

export default function ProgrammePage() {
  return (
    <>
      <Nav />
      <main>
        <Programme />
      </main>
      <Footer />
    </>
  );
}
